import * as Sentry from '@sentry/react';
import { sentryUnhandledRejectionFormatter } from '@source/utils/utils';

if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true') {
  const replay = Sentry.replayIntegration();

  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.consoleLoggingIntegration({ levels: [] }), replay],
    enableLogs: true,
    tracesSampleRate: 0.5,

    //  performance
    //  session-replay
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    //  session-replay

    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || 'development',
  });

  if (typeof window !== 'undefined' && 'navigation' in window) {
    window.navigation.addEventListener('navigate', (event) => {
      const url = new URL(event.destination.url);
      const replayPages = ['/buy-now'];
      const isRecord = replayPages.some((page) => url.pathname.includes(page));

      try {
        if (isRecord) {
          // Start recording when user navigates to the target URL
          replay.start();
        } else {
          // Stop recording when user navigates away from the target URL
          replay.stop();
        }
      } catch (error) {
        console.log('Error with Sentry replay:', error);
      }
    });
  }
}
